import React, {useContext, useEffect, useState} from 'react';
import TabSwitch from '../../components/atoms/TabSwitch';
import {useTranslation} from '../../context/language';
import {Container, IconButton} from './styles';
import RequestNewRemittance from '../../components/templates/RequestNewRemittance';
import History from '../../components/templates/History';
import {TabSwitchContext} from '../../context/tabSwtich';
import BackArrow from '../../assets/icons/BackArrow.svg';
import {useNavigate} from 'react-router-dom';
import Text from '../../components/atoms/Text';
import {theme} from '../../styles/darkTheme';

const RequestRemittance = () => {
  const {text} = useTranslation();
  const [top, setTop] = useState<HTMLDivElement | null>();
  const history = useNavigate();

  useEffect(() => {
    if (top) {
      top.scrollIntoView();
    }
  }, [top]);

  return (
    <>
      <div ref={el => setTop(el)}></div>
      <Container>
        <div style={{display: 'flex', flexDirection: 'row'}} onClick={() => history(-1)}>
          <IconButton src={BackArrow} size={24} />
          <Text fontWeight={'bold'} fontColor={theme.primary}>{text.requestRemittance}</Text>
        </div>
          <RequestNewRemittance />
      </Container>
    </>
  );
};

export default RequestRemittance;
